import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import Page from "webPage/Page";
import PageAnimations from "webPage/PageAnimations";

import handleNavigation from "navigation";
import handleTracks from "track";
import {handleStickyNav} from "./util/handleStickyNav";

import handleTestimonialSliders from "blocks/TestimonialSlider";

import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import handleScrollingImageGrids from "blocks/ScrollingImageGrid";
import handleCountUpElements from "util/ScrollUp";
import {handleScrollingRotatingElements} from "blocks/Section";
import handleGalleryGridElements from "blocks/GalleryGrid";
import VideoModal from "modal/VideoModal";
import handleCaseStudyStatsGalleries from "blocks/CaseStudyGrid";
import {handleVideoHeros} from "blocks/VideoHero";
import {handleNewsletterForms} from "util/handleNewsletterForms";
import {handleGravityForms} from "util/handleGravityForms";
import handleTrackingClicks from "util/handleTrackingClicks";
import {handleProjectAccordion} from "./blocks/ProjectAccordion";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    gsap.registerPlugin(ScrollTrigger);

    Page.init();
    PageAnimations.start();

    handleNavigation();
    handleTracks();
    handleStickyNav();

    handleTestimonialSliders();
    handleScrollingImageGrids();
    handleScrollingRotatingElements();
    handleCountUpElements();
    handleGalleryGridElements();
    handleCaseStudyStatsGalleries();
    handleVideoHeros();
    handleNewsletterForms();
    handleGravityForms();
    handleProjectAccordion();

    handleTrackingClicks();

    $('body').on('click', '.js-video-modal', function () {
        let modal = new VideoModal($(this));
        modal.show();
        return false;
    });

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId === 1) {
            let $form = $('#gf_' + formId);
            if ($form.parents('.layout--form').length > 0) {
                $form.parents('.box').find('>*:not(.confirmation-message)').hide();
            }

            handleFormSubmitTracking();
        }
    });
});

function handleFormSubmitTracking() {

    let eventId;
    let tagManagerEvent;

    switch (window.location.pathname) {
        case '/sectors/cafe-restaurant/':
            eventId = 'AW-16521779395/MRL2CKuv0acZEMOxmcY9';
            tagManagerEvent = 'submit-cafe';
            break;
        case '/sectors/community/':
            eventId = 'AW-16521779395/dX1iCPHDzacZEMOxmcY9';
            tagManagerEvent = 'submit-community';
            break;
        case 'sectors/health/':
            eventId = 'AW-16521779395/aO1NCKGf0KcZEMOxmcY9';
            tagManagerEvent = 'submit-health';
            break;
        case '/sectors/optical/':
            eventId = 'AW-16521779395/J2LNCJ6c0acZEMOxmcY9';
            tagManagerEvent = 'submit-optical';
            break;
        case '/sectors/retail-showroom/':
            eventId = 'AW-16521779395/SDahCMmg0KcZEMOxmcY9';
            tagManagerEvent = 'submit-retail';
            break;
        case '/sectors/salon-wellbeing/':
            eventId = 'AW-16521779395/QDO_CMCm0KcZEMOxmcY9';
            tagManagerEvent = 'submit-salon';
            break;
        case '/sectors/workspace/':
            eventId = 'AW-16521779395/GyUiCKm3zacZEMOxmcY9';
            tagManagerEvent = 'submit-workspace';
            break;
        case '/cafe-interior-design/':
            eventId = 'AW-16521779395/9XbrCN6TtLkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-cafe';
            break;
        case '/community-interior-design/':
            eventId = 'AW-16521779395/22-QCL-8ubkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-community';
            break;
        case '/health-and-pharmacy-interior-design/':
            eventId = 'AW-16521779395/f0bWCOfxvLkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-health';
            break;
        case '/optician-shop-design/':
            eventId = 'AW-16521779395/R0WNCOrxvLkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-optical';
            break;
        case '/shop-interior-design/':
            eventId = 'AW-16521779395/xi5mCO3xvLkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-retail';
            break;
        case '/salon-interior-design/':
            eventId = 'AW-16521779395/sxnCCNL6vLkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-salon';
            break;
        case '/office-interior-design/':
            eventId = 'AW-16521779395/KzuVCNX6vLkZEMOxmcY9';
            tagManagerEvent = 'ppc-submit-workspace';
            break;
        default:
            eventId = 'AW-16521779395/xrZNCNbE0KcZEMOxmcY9';
            tagManagerEvent = 'submit-contact';
    }

    try {
        dataLayer.push({
            'event': tagManagerEvent,
        });

        gtag('event', 'conversion', {
            'send_to': eventId, 'event_callback': function () {
                console.log('form submit callback', eventId);
            }
        });
    } catch (e) {
        console.log(e);
    }
}

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
